import { IStore } from 'redux/root';
import { INotification } from './reducer';

export const getNotifications = (store: IStore): INotification[] =>
  store.snackbar.notifications;
